import { render, staticRenderFns } from "./p-index.vue?vue&type=template&id=eeb4bba8"
import script from "./p-index.vue?vue&type=script&lang=js"
export * from "./p-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports